<template>
  <div class="shop-header" ref="shopHeaderContent">
    <!--头部广告位banner-->
    <div v-if="topAdvertisingImg && !fromListing && !isAlibabaDistributor" class="top_banner_style" @click="toClearanceList">
      <img :src="topAdvertisingImg" alt="">
    </div>
    <!--头部信息内容区域-->
    <div v-if="!isAlibabaDistributor" class="header-conter" :class="navBarFixed ? 'fixed_header_conter' : ''">
      <div class="header-conter-box">
        <!--logo图标-->
        <img :src="logoUrl" width="210" height="22" style="cursor: pointer;vertical-align: middle" @click="toIndex" :alt="$t('key1000009')">
        <!--搜索框-->
        <div class="search-center">
          <div class="flex align-items">
            <Input v-model.trim="searchValue" class="search-input" :placeholder="$t('key1000034')" @on-enter="searchBtn">
              <Tooltip max-width="200" placement="top" class="ml5 cursor" transfer :content="$t('key1000035')" slot="suffix">
                <Upload
                  ref="upload"
                  name="files"
                  :headers="headObj"
                  :action="fileApi"
                  :data="uploadData"
                  :show-upload-list="false"
                  :before-upload="handleBeforeUpload"
                  :on-success="uploadSuccess"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="20480"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize">
                  <Icon type="ios-camera-outline" :size="28"/>
                </Upload>
              </Tooltip>
            </Input>
            <button class="search-btn" @click="searchBtn">
              <span class="text">{{ $t('key1000011') }}</span>
            </button>
          </div>
          <p class="hot-word" v-if="searchWord && searchWord.length">
            <span v-for="item in searchWord" @click="keySearch(item)">{{ item.name }}</span>
          </p>
        </div>
        <!--语种-->
        <Dropdown @on-click="changeLanguage" class="languages">
          <div class="flex align-items-center cursor">
            <img :src="flagPath" width="24" height="16" class="cursor" alt="">
            <span class="font-size-12 color-white mr8 ml8">{{ selectLang }}</span>
            <Icon color="#fff" type="ios-arrow-down"></Icon>
          </div>
          <DropdownMenu slot="list">
            <Dropdown-item v-for="(item, index) in languageList" :name="item.name" :key="index">
              <div class="language_item_style">
                <img :src="item.iconPath" width="24" height="16" class="cursor mr10" alt="">
                <span class="font-size-12">{{ item.title }}</span>
                <Icon class="ml8" type="md-checkmark" size="18" color="#89b92a" v-if="flagPath == item.iconPath"/>
              </div>
            </Dropdown-item>
          </DropdownMenu>
        </Dropdown>
        <span class="line_item">|</span>
        <!--售卖国/地区-->
        <template v-if="showProductSaleCountrySet">
          <div class="flex align-items-center">
            <Icon color="#fff" size="24" type="ios-pin-outline"/>
            <div class="flex flex-direction">
              <span class="font-size-12 color-white">{{ $t('key1000036') }}</span>
              <Select v-model="sellingCountry" filterable size="small" class="sellingCountry_box" @on-change="sellingCountryChange">
                <Option v-for="item in sellingCountryData" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
            </div>
          </div>
          <span class="line_item">|</span>
        </template>
        <!--头像-->
        <Dropdown @on-click="changeUserInfo">
          <i class="iconfont cursor font-size-24 color-white" v-html="'&#xe665;'"></i>
          <DropdownMenu slot="list">
            <template v-if="userInfo">
              <DropdownItem name="messageCenter">{{ $t('key1000037') }}</DropdownItem>
              <DropdownItem name="personalCenter">{{ $t('key1000038') }}</DropdownItem>
              <DropdownItem name="myCollection">{{ $t('key1000039') }}</DropdownItem>
              <DropdownItem name="helpCenter">{{ $t('key1000027') }}</DropdownItem>
              <DropdownItem name="logOut" divided>{{ $t('key1000040') }}</DropdownItem>
            </template>
            <template v-else>
              <DropdownItem name="register">
                <p class="font-size-12 color-333 mb10">{{ $t('key1000041') }}</p>
                <p class="signUpForFree_box">{{ $t('key1000042') }}</p>
              </DropdownItem>
              <DropdownItem name="login">
                <p class="login_box">{{ $t('key1000043') }}</p>
              </DropdownItem>
            </template>
          </DropdownMenu>
        </Dropdown>
        <span class="line_item">|</span>
        <!--购物车-->
        <i class="iconfont cursor font-size-24 color-white" v-html="'&#xe63b;'" @click="myShoppingCartUrl"></i>
      </div>
      <!--所有分类区域-->
      <div class="wid100P back-fff">
        <div class="classification-box" v-if="showBoxTalg || $route.path !=='/index'">
          <div class="classification-title" :class="showHoverTalg ? 'show-hover' : ''">
            <div class="flex align-items" style="width: 240px;">
              <Icon type="md-menu" size="26" color="#89b92a" class="ml12"/>
              <p class="title">{{ $t('key1000012') }}</p>
            </div>
            <!--分类-->
            <div class="menu-box">
              <trsCategoryTree
                :sourceData="menuList"
                :defaultSelectedValue="defaultCategoryId"
                @select="toListBtn"
              />
            </div>
          </div>
          <!--商品参与活动的tab栏-->
          <activityTab></activityTab>
        </div>
      </div>
    </div>
    <!--侧边广告位-->
    <sideAdvertisingSpace v-if="!fromListing && !isAlibabaDistributor" :setTop="setTop"></sideAdvertisingSpace>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import shopHeader from './common/shopHeader';
import storeHeader from './common/storeHeader';
import sideAdvertisingSpace from "@/components/common/sideAdvertisingSpace";
import Mixin from "@/components/mixin/common_mixin";
import {
  advertisingLinkAddress, isAlibabaDistributor, pageJump, handleLogoUrl, changeUserLanguages, getDomainSiteInfo,
  commonSessionStorage, commonLocalStorage, getAllCountrysData, getHrefPath, checkLogin, getCloudTreeData, getSystemDomainNameData, getDeliveryAreasAllData
} from "@/utils/common";
import api from "@/api";
import {getSystemLanguage, getStoreDomainName} from "@/utils/user";
import {getToken, removeToken} from "@/utils/cookie";
import activityTab from "@/components/common/activityTab.vue";
import trsCategoryTree from "@/components/layout/shopping/common/trsCategoryTree.vue";
import {getAppScrollContainer, getAppScrollTop} from "@/utils/appScroll";

export default {
  name: 'trsHeader',
  mixins: [Mixin],
  data() {
    return {
      menuList: [],
      supplierDomain: '',
      jumpTargetObj: null,
      setTop: null,
      searchValue: this.$route.query.searchValue || '',
      searchWord: [],
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      uploadData: {},
      imageSearch: {},
      selectLang: commonSessionStorage.getItem('selectLang') || '',
      flagPath: commonSessionStorage.getItem('flagPath') || '',
      sellingCountry: 'CN',
      sellingCountryData: [],
      distributorDomain: null,
      scrollContainer: null,
      defaultCategoryId: null
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    topAdvertisingImg() {
      let advertisingList = this.$store.state.mallAdvertising;
      let imagePath = '';
      if (advertisingList && advertisingList.length > 0) {
        advertisingList.map((item) => {
          // 顶部广告位
          if (item.orientationType === 0) {
            if (item.status) {
              imagePath = item.ymsAdvertisementDetailBos[0].imagePath;
              this.jumpTargetObj = item.ymsAdvertisementDetailBos[0];
            }
          }
        });
      }
      return imagePath;
    },
    navBarFixed() {
      return this.$store.state.navBarFixed;
    },
    fromListing() {
      return this.$store.state.fromListing
    },
    isAlibabaDistributor() {
      return isAlibabaDistributor()
    },
    // logo图
    logoUrl() {
      return handleLogoUrl();
    },
    // 是否隐藏频道tab栏
    showBoxTalg() {
      return this.$store.state.navBarFixed;
    },
    showHoverTalg() {
      return this.$store.state.showHover || this.$route.path !=='/index';
    },
    // 是否展示售卖国
    showProductSaleCountrySet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.enableProductSaleCountrySet) === 1;
    }
  },
  components: {
    trsCategoryTree,
    activityTab,
    shopHeader,
    storeHeader,
    sideAdvertisingSpace
  },
  mounted() {
    this.dynamicTopHeight();
    this.scrollContainer = getAppScrollContainer();
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener('scroll', this.handleScroll);
    }
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
  beforeDestroy() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll);
      this.scrollContainer = null;
    }
  },
  created() {
    this.getSearchWord();
    this.getIpAddressCountry();
    getSystemDomainNameData().then((data) => {
      if (data) {
        let {distributorDomain, supplierDomain, ymsCoreDomain} = data;
        this.distributorDomain = distributorDomain;
        this.getClassificationData(distributorDomain);
      }
    })
    getSystemLanguage(this.userInfo).then(({langCode, configureLanguage}) => {
      this.languageList = configureLanguage;
      configureLanguage.map(item => {
        if (item.name === langCode) {
          this.flagPath = item.iconPath;
          this.selectLang = item.title;
        }
      });
      this.systemDefaultLanguage(langCode);
    });
  },
  methods: {
    // 获取所有分类的数据
    getClassificationData(distributorDomain) {
      let v = this;
      v.menuList = [];
      getDomainSiteInfo(distributorDomain).then((list) => {
        if (list && list.length > 0) {
          let ymsSiteId = list[0].ymsSiteId;
          getCloudTreeData(api.post_ymsProductCategory_shopping_queryForExistsProduct, null, null, ymsSiteId).then((data) => {
            v.menuList = data;
          });
        }
      })
    },
    // 获取搜索词
    getSearchWord() {
      let v = this;
      v.axios.get(api.get_ymsProductInfo_queryPopulerCategoryNameBySkuNumber).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          v.searchWord = data;
        }
      });
    },
    // 处理滚动吸顶
    handleScroll() {
      let v = this;
      if (v.$route.path !== '/shopList') {
        let scrollTop = getAppScrollTop(v.scrollContainer);
        let talgHeight = v.$refs['shopHeaderContent'] ? v.$refs['shopHeaderContent'].offsetHeight + 15 : 15;
        if (scrollTop > talgHeight) {
          v.searchBoxFixed = true;
        } else {
          v.searchBoxFixed = false;
        }
        v.$store.commit('navBarFixed', v.searchBoxFixed);
      }
    },
    // 头部的高度
    dynamicTopHeight() {
      let v = this;
      v.$store.commit('navBarFixed', false);
      setTimeout(() => {
        v.$nextTick(() => {
          let talgHeight = v.$refs['shopHeaderContent'] ? v.$refs['shopHeaderContent'].offsetHeight + 15 : 15;
          v.setTop = talgHeight;
          v.handleScroll();
        });
      }, 2000);
    },
    // 免费注册
    register() {
      pageJump('/login.html#/register', '/yms-shopping-service', '_self');
    },
    // 点击头部广告位的banner图
    toClearanceList() {
      let v = this;
      advertisingLinkAddress(v.jumpTargetObj);
    },
    toIndex() {
      let v = this;
      if (v.fromListing) {
        v.$router.push({
          path: '/index',
          query: {
            from: v.fromListing ? 'listing' : undefined
          }
        });
      } else {
        window.location.href = v.distributorDomain;
      }
    },
    keySearch(item) {
      let v = this;
      this.$router.push({
        path: '/shopList',
        query: {
          ymsProductCategoryId: item.ymsProductCategoryId,
          from: v.fromListing ? 'listing' : undefined
        }
      });
    },
    // 模糊搜索
    searchBtn() {
      let obj = {};
      this.imageSearch = {};
      if (this.searchValue) {
        obj = {
          searchValue: this.searchValue
        };
      }
      // 当搜索的关键词为空，默认筛选全部商品
      else if (Object.keys(this.imageSearch).length <= 0) {
        obj = {
          activityTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000033')
        }
      }
      this.$router.push({
        path: '/shopList',
        query: obj
      });
    },
    // 上传图片之前
    handleBeforeUpload(file) {
      let v = this;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64Data = reader.result;
          v.imageSearch['base64Url'] = base64Data;
          resolve(file);
        };
        // 读取文件内容，并将其转换为 Base64 编码数据
        reader.readAsDataURL(file);
      });
    },
    // 上传成功
    uploadSuccess(response, file, fileList, type) {
      let v = this;
      let data = response.datas[0];
      if (data) {
        v.searchValue = '';
        v.imageSearch.imgUrl = data;
        v.$router.push({
          path: '/shopList',
          query: {
            imgUrl: v.imageSearch.imgUrl,
            base64Url: v.imageSearch.base64Url
          }
        });
      }
    },
    // 校验文件格式
    handleFormatError(file) {
      let v = this;
      v.$Message.warning({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000028')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000029')}`,
        duration: 5
      });
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 切换语种
    changeLanguage(lang) {
      const v = this;
      v.$store.commit('setLanguages', lang);
      localStorage.setItem('setLanguages', lang);
      const langItem = v.languageList.find(item => item.name === lang);
      if (!langItem) return;
      const {name, title, iconPath} = langItem;
      const applyCommonStorage = () => {
        localStorage.setItem('lang', name);
        commonSessionStorage.setItem('flagPath', iconPath);
        commonSessionStorage.setItem('selectLang', title);
      };
      const reloadByDomain = () => {
        // 判断是否在店铺域名下
        const hasStoreDomain = getStoreDomainName();
        const delay = hasStoreDomain ? 1200 : 500;
        if (hasStoreDomain) {
          window.location.href = `${window.location.origin}?lang=${name}`;
        }
        setTimeout(() => window.location.reload(), delay);
      };
      // 已登录
      if (Object.keys(v.userInfo).length > 0) {
        changeUserLanguages(lang).then((success) => {
          if (!success) return;
          v.flagPath = iconPath;
          v.selectLang = title;
          applyCommonStorage();
          reloadByDomain();
        });
        return;
      }
      // 未登录
      localStorage.setItem('lang', name);
      reloadByDomain();
    },
    // 获取IP地址所在地国家
    getIpAddressCountry() {
      if (this.system === 'shopping') {
        if (this.showProductSaleCountrySet) {
          let sellingCountry = commonLocalStorage.getItem('sellingCountry');
          getAllCountrysData('cn', true).then((data) => {
            this.sellingCountryData = data;
            if (sellingCountry) {
              commonLocalStorage.setItem('sellingCountry', sellingCountry);
              this.sellingCountry = sellingCountry;
            } else {
              this.axios.get(api.get_ymsDistributorProductInfo_shopping_queryIpAddressCountryInfo).then(response => {
                if (response.data.code === 0) {
                  let data = response.data.datas || 'CN';
                  commonLocalStorage.setItem('sellingCountry', data);
                  this.sellingCountry = data;
                }
              });
            }
          });
        }
        getDeliveryAreasAllData().then((data) => {
          let ymsDeliveryPlaceId = commonLocalStorage.getItem('ymsDeliveryPlaceId');
          if (!ymsDeliveryPlaceId) {
            commonLocalStorage.setItem('ymsDeliveryPlaceId', data[0].ymsDeliveryPlaceId);
          }
        });
      }
    },
    // 选择售卖国
    sellingCountryChange(val) {
      if (val) {
        commonLocalStorage.setItem('sellingCountry', val);
        this.$store.commit('updateSellingCountry', Date.now())
      }
    },
    // 切换用户信息
    changeUserInfo(name) {
      let link = '';
      switch (name) {
        // 消息中心
        case 'messageCenter':
          link = getHrefPath('/distributor.html#/newsList', '/yms-distributor-service');
          window.open(link, '_blank');
          break;
        // 个人中心
        case 'personalCenter':
          link = getHrefPath('/distributor.html#/commodityList', '/yms-distributor-service');
          window.open(link, '_blank');
          break;
        // 我的收藏
        case 'myCollection':
          link = getHrefPath('/distributor.html#/commodityList', '/yms-distributor-service');
          window.open(link, '_blank');
          break;
        // 帮助中心
        case 'helpCenter':
          link = getHrefPath('/index.html#/help', '/yms-shopping-service');
          window.open(link, '_blank');
          break;
        // 退出登录
        case 'logOut':
          this.axios.get(api.get_logout + getToken('signOut')).then(response => {
            if (response.data.code === 0) {
              removeToken().then(() => {
                setTimeout(() => {
                  this.$store.commit('erpConfig', {});
                  location.reload();
                  // 在商城退出不需要重定向到登录页面
                  // let url = deleteTicket(window.location.href);
                  // window.location.href = response.data.others.logOutUrl + encodeURIComponent(url);
                }, 1500);
              });
            }
          });
          break;
        // 注册
        case 'register':
          link = getHrefPath('/login.html#/register', '/yms-shopping-service');
          window.open(link, '_blank');
          break;
        // 登录
        case 'login':
          link = getHrefPath('/login.html#/login' + '?u=' + window.location.href, '/yms-shopping-service');
          window.open(link, '_self');
          break;
      }
    },
    // 购物车
    myShoppingCartUrl() {
      let v = this;
      if (v.system === 'distributor') {
        pageJump('/index.html#/shoppingCartList', '/yms-shopping-service', '_blank');
      } else {
        checkLogin(true).then(() => {
          setTimeout(() => {
            const {href} = v.$router.resolve({
              path: '/shoppingCartList',
            });
            window.open(href, '_blank');
          }, 1200);
        });
      }
    },
    // 选择分类菜单
    toListBtn(data) {
      this.$router.push({
        path: '/shopList',
        query: {
          ymsProductCategoryId: data.ymsProductCategoryId,
          from: this.fromListing ? 'listing' : undefined
        }
      });
    },
  },
  watch: {
    $route: {
      handler(data) {
        let v = this;
        v.dynamicTopHeight();
      },
      deep: true,
      immediate: true
    },
  }
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.shop-header {
  width: 100%;
  background: #FFFFFF;
  margin-bottom: 15px;
  position: relative;

  .top_banner_style {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #FBDBE0;
    cursor: pointer;

    img {
      height: 100%;
    }
  }

  .header-conter {
    width: 100%;
    background-color: #6eaf39;

    .header-conter-box {
      margin: 0 auto;
      width: 1200px;
      height: 90px;
      display: flex;
      align-items: center;

      .search-center {
        font-family: PingFang SC;
        width: 480px;
        margin: 0 42px 0 37px;

        .hot-word {
          font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
          font-weight: 400;
          font-style: normal;
          font-size: 12px;
          margin-top: 6px;
          color: #ffffff;
          opacity: 0.8;

          span {
            margin-right: 10px;
            cursor: pointer;
          }

          span:hover {
            font-weight: 600;
          }
        }

        .search-input {
          flex: 1;

          /deep/ .ivu-input {
            width: 410px;
            height: 40px;
            line-height: 40px;
            color: #666;
            box-shadow: none !important;
            outline: none;
            padding: 0 10px;
            font-size: 14px;
            border-radius: 6px 0px 0px 6px;
            background-color: #D4E7C4;
          }

          /deep/ .ivu-input-suffix {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-right: 20px;
          }

          /deep/ .ivu-input-with-suffix {
            padding-right: 48px;
          }

          /deep/ .ivu-input:hover {
            border-color: transparent;
          }

          /deep/ .ivu-input:focus {
            border-color: transparent !important;
          }
        }

        /deep/ .search-input .ivu-input::-webkit-input-placeholder {
          color: #333333;
          opacity: 0.5;
        }

        /deep/ .search-input .ivu-input:-moz-placeholder {
          color: #333333;
          opacity: 0.5;
        }

        /deep/ .search-input .ivu-input::-moz-placeholder {
          color: #333333;
          opacity: 0.5;
        }

        /deep/ .search-input .ivu-input:-ms-input-placeholder {
          color: #333333;
          opacity: 0.5;
        }

        .search-btn {
          font-size: 14px;
          width: 72px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-weight: 400;
          color: #000;
          background-color: #f0c143;
          border: none;
          outline: none;
          cursor: pointer;
          border-bottom-right-radius: 5px;
          border-top-right-radius: 5px;
        }
      }

      .line_item {
        color: #fff;
        opacity: 0.3;
        margin: 0 20px;
      }

      .sellingCountry_box {
        width: 120px;

        /deep/ .ivu-select, .ivu-select-input {
          background-color: #D4E7C4;
          font-size: 12px !important;
        }

        /deep/ .ivu-select-selection:hover {
          border-color: transparent !important;
        }

        /deep/ .ivu-select-selection {
          border-color: transparent !important;
          box-shadow: none !important;
          background-color: #D4E7C4;
        }

        /deep/ .ivu-select-input::-webkit-input-placeholder {
          color: #333333;
          opacity: 0.5;
        }

        /deep/ .ivu-select-input:-moz-placeholder {
          color: #333333;
          opacity: 0.5;
        }

        /deep/ .ivu-select-input::-moz-placeholder {
          color: #333333;
          opacity: 0.5;
        }

        /deep/ .ivu-select-input:-ms-input-placeholder {
          color: #333333;
          opacity: 0.5;
        }
      }

      .signUpForFree_box {
        border: 1px solid #7DBA47;
        border-radius: 6px;
        color: #7DBA47;
        font-size: 12px;
        cursor: pointer;
        width: 120px;
        height: 30px;
        line-height: 30px;
        text-align: center;
      }

      .login_box {
        background-color: #7DBA47;
        color: #fff;
        font-size: 12px;
        cursor: pointer;
        border-radius: 6px;
        width: 120px;
        height: 30px;
        line-height: 30px;
        text-align: center;
      }
    }
  }

  .fixed_header_conter {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1500);
  }

  .classification-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    height: 55px;
    background-color: #ffffff;

    .classification-title {
      height: 44px;
      display: flex;
      width: 280px;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      position: relative;
      color: #89b92a;

      .title {
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: bold;
        padding-left: 12px;
      }
    }

    .show-hover {
      cursor: pointer;

      .menu-box {
        display: none;
        position: absolute;
        left: 0;
        top: 39px;
        z-index: 1000;

      }

      &:hover {
        .menu-box {
          display: flex !important;
          box-shadow: 0 0 18px 0 rgba(0, 0, 0, .1);
        }
      }
    }
  }
}

.languages .flag {
  height: 32px;
  width: 32px;
  background: url('../../../assets/images/flags.png') no-repeat;
}

.languages .zh-CN {
  background-position: 0 -32px;
}

.languages .en-US {
  background-position: 0 0;
}
</style>
